<div class="auth">
  <div class="login-form">
    @if (loginType.isUsername) {
      <form [formGroup]="loginForm" (submit)="onLoginClick()">
        <h3>{{ 'auth.signIn' | translate }}</h3>
        <div class="form-group">
          <label class="required">{{ 'auth.password' | translate }}</label>
          <div style="position: relative">
            <dx-text-box
              valueChangeEvent="change keyup"
              formControlName="password"
              placeholder="{{ 'auth.password' | translate }}"
              [(mode)]="passwordMode">
            </dx-text-box>
            <a
              href="javascript:void(0)"
              class="password_mode_btn"
              (click)="onPasswordViewClick()"
              [ngClass]="{
                'icon-view': passwordMode !== 'text',
                'icon-view_off': passwordMode === 'text',
              }"></a>
          </div>
          @if (displayRequiredError(loginForm?.get('password'))) {
            <div class="ng-invalid-comment">
              {{ 'validation.required' | translate }}
            </div>
          }
        </div>
        <div class="submit">
          <dx-button
            class="btn-xl btn-rounded"
            stylingMode="contained"
            type="default"
            text="{{ 'auth.signIn' | translate }}"
            [useSubmitBehavior]="true">
          </dx-button>
        </div>
        <div class="footer-link">
          <a href="javascript:void(0)" (click)="onSwitchToForgotPassword()">
            {{ 'auth.forgotPassword' | translate }}
          </a>
        </div>
      </form>
    }
    @if (loginType.isEmail) {
      <form>
        <div class="mt50 acenter">
          <div>{{ 'auth.matchingEmail' | translate }}</div>
          <a href="javascript:void(0)" (click)="onSelectEmail()" class="simple-lnk"
            >{{ 'auth.oneTimeCode' | translate }}?</a
          >
        </div>
      </form>
    }
    @if (loginType.isSms) {
      <form>
        <div class="mt50 acenter">
          <div>{{ 'auth.matchingPhone' | translate }}</div>
          <a href="javascript:void(0)" (click)="onSelectSms()" class="simple-lnk"
            >{{ 'auth.oneTimeCode' | translate }}?</a
          >
        </div>
      </form>
    }
    @if (!loginType.isUsername && !loginType.isSms && !loginType.isEmail) {
      <form>
        <h3>{{ 'auth.userNotFound' | translate }}</h3>
        @if (!portalSetup?.allowNewClientRegisterOnline) {
          <div class="mb20 acenter">
            {{ 'auth.userNotFoundDesc' | translate: { userName: loginType.value } }}
          </div>
        }
        @if (portalSetup?.allowNewClientRegisterOnline) {
          <div class="mb20 acenter">
            {{ 'auth.userNotFoundDescWithCreate' | translate: { userName: loginType.value } }}
          </div>
        }
        @if (portalSetup?.allowNewClientRegisterOnline) {
          <div class="grid-row">
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-xl simple-btn-rounded simple-btn-accent simple-btn-shadow bigger-side-pads"
              (click)="onSwitchToEmailConfirmation()">
              <span>{{ 'auth.createAccount' | translate }}</span>
            </a>
          </div>
        }
      </form>
    }
  </div>
  @if (canReturn) {
    <div class="form-footer">
      <a
        href="javascript:void(0)"
        class="simple-btn simple-btn-sm simple-btn-rounded simple-btn-dark-line"
        (click)="onSwitchToLoginSelection()">
        <i class="icon-left-arrow"></i>
        <span>{{ 'general.back' | translate }}</span>
      </a>
    </div>
  }
</div>
